import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Twitter, Instagram, Github, ChevronRight } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { useToast } from '../hooks/use-toast';

const Footer = () => {
  const [email, setEmail] = useState('');
  const { toast } = useToast();

  const handleNewsletter = (e) => {
    e.preventDefault();
    if (email) {
      toast({
        title: "Subscribed!",
        description: "Thank you for subscribing to our newsletter.",
      });
      setEmail('');
    }
  };

  return (
    <footer>
      {/* Footer Top */}
      <div className="bg-gray-900 text-white py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* About */}
            <div>
              <div className="border-l-4 border-yellow-500 pl-4 mb-6">
                <h3 className="text-xl font-bold">ABOUT US</h3>
              </div>
              <Link to="/" className="flex items-center gap-2 mb-4">
                <span className="text-3xl"></span>
                <span className="text-2xl font-bold">ARANVIC</span>
              </Link>
              <p className="text-gray-400 mb-6">
                Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor inci done idunt ut labore et dolore magna aliqua.
              </p>
              <div className="flex gap-3">
                <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  <Facebook size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  <Twitter size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  <Instagram size={20} />
                </a>
                <a href="#" className="text-gray-400 hover:text-yellow-500 transition-colors">
                  <Github size={20} />
                </a>
              </div>
            </div>

            {/* Working Hours */}
            <div>
              <div className="border-l-4 border-yellow-500 pl-4 mb-6">
                <h3 className="text-xl font-bold">WORKING HOURS</h3>
              </div>
              <p className="text-gray-400 mb-6">
                We work 7 days a week, every day excluding major holidays. Contact us if you have an emergency, with our Hotline and Contact form.
              </p>
              <div className="space-y-2 text-gray-400">
                <div className="flex justify-between">
                  <span>Monday - Friday:</span>
                  <span className="text-white">10:00 - 16:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Saturday:</span>
                  <span className="text-white">12:00 - 15:00</span>
                </div>
                <div className="flex justify-between">
                  <span>Sunday and holidays:</span>
                  <span className="text-white">09:00 - 12:00</span>
                </div>
              </div>
            </div>

            {/* Services */}
            <div>
              <div className="border-l-4 border-yellow-500 pl-4 mb-6">
                <h3 className="text-xl font-bold">SERVICES</h3>
              </div>
              <ul className="space-y-2">
                <li>
                  <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors">
                    <ChevronRight size={16} />
                    Industrial Instrumentation
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors">
                    <ChevronRight size={16} />
                    Battery Refurbishment & Life Extension
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors">
                    <ChevronRight size={16} />
                    Engineering Design & Product Development
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors">
                    <ChevronRight size={16} />
                    PCB DESIGN
                  </Link>
                </li>
                <li>
                  <Link to="/services" className="flex items-center gap-2 text-gray-400 hover:text-yellow-500 transition-colors">
                    <ChevronRight size={16} />
                    Manufacturing & Fabrication
                  </Link>
                </li>
              </ul>
            </div>

            {/* Newsletter */}
            <div>
              <div className="border-l-4 border-yellow-500 pl-4 mb-6">
                <h3 className="text-xl font-bold">NEWSLETTER</h3>
              </div>
              <p className="text-gray-400 mb-4">Stay updated with our latest news and offers</p>
              <form onSubmit={handleNewsletter} className="space-y-3">
                <Input
                  type="email"
                  placeholder="Your Email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="bg-gray-800 border-gray-700 text-white"
                  required
                />
                <Button type="submit" className="w-full bg-yellow-500 hover:bg-yellow-600 text-white">
                  Subscribe
                </Button>
              </form>
            </div>
          </div>
        </div>
      </div>

      {/* Footer Bottom */}
      <div className="bg-yellow-500 py-4">
        <div className="container mx-auto px-4">
          <div className="flex flex-col md:flex-row justify-between items-center text-sm">
            <div className="text-gray-800 mb-2 md:mb-0">
              Copyright © 2025, Designed & Developed by  Allreach
            </div>
            <div className="flex gap-6">
              <Link to="/about" className="text-gray-800 hover:text-white transition-colors">About</Link>
              <Link to="/team" className="text-gray-800 hover:text-white transition-colors">Our people</Link>
              <Link to="/faq" className="text-gray-800 hover:text-white transition-colors">Faq</Link>
              <Link to="/news" className="text-gray-800 hover:text-white transition-colors">Blog</Link>
              <Link to="/pricing" className="text-gray-800 hover:text-white transition-colors">Pricing</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;